import { RoomAir } from "../model/roomAir";
import { Volume } from "../model/volume";
import { ArrayUtils } from "./arrayUtils";
import { NumberUtils } from "./numberUtils";


export class RoomUtils {


  static getTotalVolume(room: RoomAir): number {
    return NumberUtils.sumWithoutPresicion(room.volumes.map(v => v.surface * v.height));
  }

  static getTotalVolumeRound(volumes: Volume[]): number {
    return NumberUtils.round(NumberUtils.fixPrecision(ArrayUtils.sum(volumes.map(v => v.surface * v.height))), 1);
  }

  static calculatePoints(volume: number): number {
    let points = 0;

    if (volume <= 2) {
      points = 1;
    } else if (volume <= 4) {
      points = 2;
    } else if (volume <= 6) {
      points = 3;
    } else if (volume <= 8) {
      points = 4;
    } else if (volume <= 10) {
      points = 5;
    } else if (volume <= 24) {
      points = 6;
    } else if (volume <= 28) {
      points = 7;
    } else if (volume <= 32) {
      points = 8;
    } else if (volume <= 36) {
      points = 9;
    } else if (volume <= 52) {
      points = 10;
    } else if (volume <= 56) {
      points = 11;
    } else if (volume <= 64) {
      points = 12;
    } else if (volume <= 68) {
      points = 13;
    } else if (volume <= 72) {
      points = 14;
    } else if (volume <= 76) {
      points = 15;
    } else if (volume <= 104) {
      points = 16;
    } else if (volume <= 108) {
      points = 17;
    } else if (volume <= 116) {
      points = 18;
    } else if (volume <= 148) {
      points = 19;
    } else if (volume <= 156) {
      points = 20;
    } else if (volume <= 192) {
      points = 21;
    } else if (volume <= 232) {
      points = 22;
    } else if (volume <= 276) {
      points = 23;
    } else if (volume <= 352) {
      points = 24;
    } else if (volume <= 436) {
      points = 25;
    } else if (volume <= 636) {
      points = 26;
    } else if (volume <= 1000) {
      points = 27;
    }

    return points;
  }

}